import { ArrowRight, ShieldCheck, MapPin, BadgeCheck, Star, Phone, CarFront } from 'lucide-react';
import PageVideoBg from '@/components/PageVideoBg';
import { SiteHeader } from './SiteHeader';
import { SOCIAL } from '@/components/ReviewRow';
import { TrustpilotSummary } from './TrustpilotSummary';

const clips = ['page-bg-1-orbit-v3', 'page-bg-2-orbit-v3', 'page-bg-3-v2'].map((name) => ({
  landscape: `/img/${name}-landscape.mp4`, portrait: `/img/${name}-portrait.mp4`,
  posterLandscape: `/img/${name}-landscape-poster.jpg`, posterPortrait: `/img/${name}-portrait-poster.jpg`,
}));

export const HomeHero = ({ onQuote, heroRef, onMenuChange }) => (
  <>
    <div className="e-hero-wrap" data-testid="hero-bg-wrap">
      <PageVideoBg clips={clips} speed={3} />
      <div className="e-hero-overlay" aria-hidden="true" data-testid="hero-text-gradient" />
      <div className="e-hero-fade" aria-hidden="true" data-testid="hero-black-fade" />
      <SiteHeader onMenuChange={onMenuChange} />
      <section ref={heroRef} className="e-hero e-container" data-testid="hero-split">
        <div className="e-hero-copy">
          <p className="e-eyebrow" data-testid="hero-eyebrow">Mobilt elbilværksted i Østjylland</p>
          <h1 data-testid="hero-heading">Vi kommer til dig.</h1>
          <p className="e-hero-description" data-testid="hero-description">Service og reparation af din el- eller hybridbil hjemme eller på arbejdet. Faste priser uden kørselsgebyr.</p>
          <div className="e-hero-actions">
            <a href="#services" className="e-button" data-testid="hero-book-btn">Se priser og book tid <ArrowRight size={18} /></a>
            <button type="button" onClick={onQuote} className="e-text-link" data-testid="hero-quote-btn">Få et tilbud <ArrowRight size={16} /></button>
          </div>
          <div className="e-hero-contact" data-testid="hero-contact-row">
            <TrustpilotSummary />
            <a href="tel:+4593954164" className="e-hero-phone" aria-label="Ring til E Service på 93 95 41 64" data-testid="hero-call-link">
              <Phone size={18} aria-hidden="true" /><span>93 95 41 64</span>
            </a>
          </div>
        </div>
      </section>
    </div>
    <div className="e-container e-trust" lang="da" data-testid="home-trust-strip">
      <div className="e-trust-item" data-testid="trust-factory-warranty"><ShieldCheck size={20} aria-hidden="true" /><span>Fabriksgaranti bevaret</span></div>
      <div className="e-trust-item" data-testid="trust-no-travel-fee"><MapPin size={20} aria-hidden="true" /><span>Intet kørselsgebyr</span></div>
      <div className="e-trust-item" data-testid="trust-parts-warranty"><BadgeCheck size={20} aria-hidden="true" /><span>2 års reservedels&shy;garanti</span></div>
      <a className="e-trust-item" href={SOCIAL.trustpilot.href} target="_blank" rel="noopener noreferrer" data-testid="trust-reviews-link"><Star size={20} aria-hidden="true" /><span>Læs anmeldelser</span></a>
      <div className="e-trust-item" data-testid="trust-all-electric-cars"><CarFront size={20} aria-hidden="true" /><span>Alle Elbiler</span></div>
    </div>
  </>
);